import { render, staticRenderFns } from "./EPosta.vue?vue&type=template&id=ed7f21f2&scoped=true"
import script from "./EPosta.vue?vue&type=script&lang=ts"
export * from "./EPosta.vue?vue&type=script&lang=ts"
import style0 from "./EPosta.vue?vue&type=style&index=0&id=ed7f21f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f21f2",
  null
  
)

export default component.exports